// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M15 2H22V22H13V16H11V22H2V2H9V7H15V2ZM4 20H7V4H4V20ZM17 4V20H20V4H17ZM14 11H10V13H14V11Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-city-3-filled')
export default class City3FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'city-3-filled',
    }
  }
}
